import * as React from "react";
import { useState } from "react";
import { RootState } from "../reducers/index";
import { useAppSelector } from "../store/index";
import { IInitOptions } from "../interfaces/initoptions";
import { PopulateLeadResponse } from "../interfaces/facilityapi";
import LeadForm from "./leadform";
import LeadWebsite from "./leadwebsite";
import LeadPhone from "./leadphone";

interface ILeadAreaProps {
    populateLead: PopulateLeadResponse;
    onHide(): void;
}

const LeadArea = ({ populateLead, onHide }: ILeadAreaProps) => {
    const [leadSubmitted, setLeadSubmitted] = useState(false);
    const { facilityName } = useAppSelector<IInitOptions>((state: RootState) =>
        state.initOptions
    );

    let leadPhone: React.JSX.Element | null = null;
    let leadWebsite: React.JSX.Element | null = null;
    if (populateLead.websiteUrl) {
        leadWebsite = <LeadWebsite websiteUrl={populateLead.websiteUrl} />;
    }
    if (populateLead.phone) {
        leadPhone = <LeadPhone phone={populateLead.phone} />;
    }

    const onSubmitted = () => {
        setLeadSubmitted(true);
    };

    if (populateLead.showForm) {
        if (leadSubmitted) {
            return (
                <div>
                    <p>
                        Your email has been sent to the provider.
                    </p>
                    <p className="text-center">
                        <input
                            type="button"
                            className="btn btn-secondary"
                            onClick={onHide}
                            value="Close Form"
                        />
                    </p>
                    <p className="form-disclaimer">
                        Please note that email communication may not be entirely
                        secure. Sending an email through this page does not
                        guarantee that the recipient will receive, read, or
                        respond to it and spam filters could prevent its
                        delivery.
                    </p>
                </div>
            );
        } else {
            let leadAlternate: React.JSX.Element | null = null;

            if (populateLead.websiteUrl || populateLead.phone) {
                leadAlternate = (
                    <div>
                        <div className="my-3 pt-3 border-top">
                            If you prefer not to use this form, you can contact
                            them directly:
                        </div>
                        {leadWebsite}
                        {leadPhone}
                    </div>
                );
            }
            return (
                <div>
                    <LeadForm onSubmitted={onSubmitted} />
                    {leadAlternate}
                </div>
            );
        }
    } else {
        // alternate contact methods?
        if (populateLead.websiteUrl || populateLead.phone) {
            return (
                <div>
                    <div className="mb-3">
                        Sorry, but {facilityName}{" "}
                        can't be contacted through our website. Alternatively,
                        You can contact them directly:
                    </div>
                    {leadWebsite}
                    {leadPhone}
                </div>
            );
        } else {
            <div className="alert alert-warning" role="alert">
                Unfortunately, {facilityName}{" "}
                doesn't have any known valid contact information! Please search
                for another provider.
            </div>;
        }
    }
};

export default LeadArea;
